import { monthLong } from '@/lib/format';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import type { Metric } from './MatrixTable';

export function MonthSelect({
  label,
  months,
  value,
  onChange,
  id,
}: {
  label?: string;
  months: string[];
  value: string;
  onChange: (v: string) => void;
  id?: string;
}) {
  return (
    <div className="space-y-1">
      {label && <Label className="text-xs">{label}</Label>}
      <Select value={value} onValueChange={onChange} disabled={!months.length}>
        <SelectTrigger className="w-40" id={id} aria-label={label}>
          <SelectValue placeholder="Mês" />
        </SelectTrigger>
        <SelectContent>
          {months.map((m) => (
            <SelectItem key={m} value={m}>
              {monthLong(m)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export function MonthRange({
  months,
  from,
  to,
  onChange,
}: {
  months: string[];
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
}) {
  return (
    <>
      <MonthSelect
        label="De"
        months={months}
        value={from}
        onChange={(v) => onChange(v, v > to ? v : to)}
      />
      <MonthSelect
        label="Até"
        months={months}
        value={to}
        onChange={(v) => onChange(v < from ? v : from, v)}
      />
    </>
  );
}

export function MetricToggle({
  value,
  onChange,
}: {
  value: Metric;
  onChange: (m: Metric) => void;
}) {
  return (
    <div className="space-y-1">
      <Label className="text-xs">Valores</Label>
      <Tabs value={value} onValueChange={(v) => onChange(v as Metric)}>
        <TabsList>
          <TabsTrigger value="gross">Bruto</TabsTrigger>
          <TabsTrigger value="net">Líquido</TabsTrigger>
          <TabsTrigger value="both">Ambos</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
}
